import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../stores/store';
import AccessDenied from '../../../features/errors/AccessDenied';

// const drawerWidth = 280;

function DashboardLayout() {    
  const { commonStore } = useStore();
  const { stationIdQuery } = commonStore;
  // const [mobileOpen, setMobileOpen] = React.useState(false);   
  
  // const handleDrawerToggle = () => {
  //   setMobileOpen(!mobileOpen);
  // };

  useEffect(() => {
    commonStore.getStations()
  }, [commonStore])
  
  if (!stationIdQuery) return <AccessDenied />
  
  return <Outlet />

  // return (
  //   <>
  //     <Box sx={{ display: 'flex' }}>
  //       <CssBaseline />
  //       {/* AppBarMenu */}
  //       <AppBarMenu handleDrawerToggle={handleDrawerToggle} drawerWidth={drawerWidth} />

  //       {/* Sidebar */}
  //       <Sidebar
  //         mobileOpen={mobileOpen}
  //         handleDrawerToggle={handleDrawerToggle}
  //         drawerWidth={drawerWidth}
  //       />

  //       {/* Main */}
  //       <Box
  //         component="main"
  //         sx={{
  //           flexGrow: 1,
  //           p: 5,
  //           width: { sm: `calc(100% - ${drawerWidth}px)` },
  //           paddingTop: 15
  //         }}
  //         height="100vh"
  //       >            
  //         <Outlet />
  //       </Box>
  //     </Box>      
  //   </>
  // );
}

export default observer(DashboardLayout);
